import { Component, OnInit } from '@angular/core';
import {ContentService} from "./content.service";
import {TourData} from '../common/elements/elements.types';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['../common/styles/container.scss', './content.component.scss']
})
export class ContentComponent implements OnInit {

  constructor( public ContentService: ContentService) { }

  defaultWorkflow: boolean = false;

  tourData: TourData[] = [
    {
      type: "image",
      src: "/img/help/tours/modules/modules_1.png",
      title: "Fully updated Modules navigation and advanced search/filter options",
      body: ""
    }, {
      type: "image",
      src: "/img/help/tours/modules/modules_2.png",
      title: "Bulk publish, unpublish or archive modules",
      body: "Change status of multiple modules at once"
    },
    {
      type: "image",
      src: "/img/help/tours/modules/modules_3.png",
      title: "Create ans apply presets for module settings and assignments",
      body: "Custom presets you create and apply for modules or training"
    },
    {
      type: "image",
      src: "/img/help/tours/modules/modules_5.png",
      title: "Updated training assignment page",
      body: "New workflow for assigning training with more flexibility and options."
    },
    {
      type: "image",
      src: "/img/help/tours/modules/modules_4.png",
      title: "Simple or advanced assignment options",
      body: ""
    },
    {
      type: "",
      src: "",
      title: "Questions or Concerns?",
      body: "If you have questions in regards to the new memo system, please submit a help request and we'll get back to you soon."
    }
  ]

  ngOnInit() {
    this.defaultWorkflow = (localStorage.getItem("defaultWorkflow") == "true");
  }

  handelDefaultWorkflow(event){

    this.defaultWorkflow = event;
    let val = event ? "true" : "false"
    localStorage.setItem("defaultWorkflow", val);

  }

}

